<template>
  <div class="inputPhoto">
    <div
      class="inputArea"
      :class="{
        disable: distance > photoMissionDistance || isCleared,
      }"
      @click="onNoLogin"
    >
      <label for="file_upload">
        <img src="@/assets/camera.svg" />
        {{ isCleared ? "達成済" : "写真をアップロード" }}

        <input
          v-if="
            !(
              distance > photoMissionDistance ||
              isLoggedInWithFirebaseAuth === false ||
              isCleared
            )
          "
          id="file_upload"
          type="file"
          accept="image/*"
          @change="onCaptureImage"
        />
        <!-- テスト用 -->
        <!-- <input
          id="file_upload"
          type="file"
          accept="image/*"
          @change="onCaptureImage"
        /> -->
      </label>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { PHOTO_MISSION_DISTANCE } from "../../const.js";
export default {
  name: "input-photo",
  props: {
    distance: { type: Number, require: true },
    isCleared: { type: Boolean, require: true },
  },
  data() {
    return {
      imgData: undefined,
    };
  },
  computed: {
    ...mapState(["isLoggedInWithFirebaseAuth"]),
    photoMissionDistance() {
      return PHOTO_MISSION_DISTANCE;
    },
    displayDistance() {
      const n = 1;
      return Math.round(this.distance * Math.pow(10, n)) / Math.pow(10, n);
    },
  },
  methods: {
    ...mapMutations(["setModal"]),
    onNoLogin() {
      if (this.isLoggedInWithFirebaseAuth === false) {
        this.setModal("signin");
        return;
      }
    },
    onCaptureImage(event) {
      if (this.isLoggedInWithFirebaseAuth === false) {
        return;
      }

      // TODO
      if (this.isCleared || this.distance > this.photoMissionDistance) {
        return;
      }

      const files = event.target.files;
      if (files.length > 0) {
        this.status = "cropping";
        this.imageFile = files[0];
      }
      this.$emit("set-img", this.imageFile);
    },
  },
};
</script>

<style lang="scss" scoped>
.inputPhoto {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .inputArea {
    margin: 0 auto;
    background: #ff7c86;
    text-align: center;
    padding: 0.75rem 0;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    width: 100%;
    justify-content: center;
    &.disable {
      background: #bfbfbf;
    }
    img {
      height: 1rem;
      margin-right: 0.5rem;
    }
    input {
      display: none;
      width: 100%;
      height: 100%;
    }
    label {
      width: 100%;
      height: 100%;
      color: white;
      display: flex;
      align-items: center;
      white-space: nowrap;
      font-size: 1.1rem;
      font-weight: 700;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Missions/InputPhoto.vue